// The one set of content every gallery panel renders, so nothing reads the
// user's real data (docs/design-system.md 6.1).
import type { TaskResource } from '@/kinds/task/apply'

const AT = '2026-10-10T09:00:00.000Z'

const task = (
  id: string,
  spec: Partial<TaskResource['spec']> & { title: string },
  state: string,
): TaskResource =>
  ({
    id,
    kind: 'Task',
    version: 1,
    name: id,
    labels: {},
    spec: { remind: false, priority: 0, ...spec },
    status: { state, actual_minutes: 0, reschedule_count: 0, last_touched: AT },
    created_at: AT,
    updated_at: AT,
    deleted_at: null,
    clocks: {},
  }) as unknown as TaskResource

export const FIXTURE_TASKS = {
  plain: task('fx-plain', { title: 'Book the dentist' }, 'next'),
  long: task(
    'fx-long',
    {
      title:
        'Reply to the landlord about the boiler service, the damp in the back bedroom and the new tenancy dates',
      estimate_minutes: 45,
      priority: 2,
    },
    'next',
  ),
  overdue: task(
    'fx-overdue',
    { title: 'Renew the car insurance', scheduled: '2026-10-01', due: '2026-10-05' },
    'next',
  ),
  done: task('fx-done', { title: 'Post the parcel' }, 'done'),
}

export const FIXTURE_ID = 'c0ffee00-1234-4abc-8def-0123456789ab'
export const FIXTURE_HASH = '9f86d081884c7d659a2feaa0c55ad015a3bf4f1b2b0b822cd15d6c15b0f00a08'
